// import styles
import 'src/shared/scss/index.scss';

import './components/';
import './shared/js/modules/click-redirect';

// only available in dev mode
if (process.env.NODE_ENV !== 'production') require('src/shared/js/dev/');

// require polyfills
require('loading-attribute-polyfill');
